import styles from './segments-manager.module.css';
import { SegmentsTable } from './SegmentsTable';
import { SegmentsTableError } from './SegmentsTableError';
import { SegmentsTableLoading } from './SegmentsTableLoading';
import { SegmentsToolbar } from './SegmentsToolbar';
import { useSegmentListView } from './useSegmentListView';

export function SegmentsManager() {
  const view = useSegmentListView();

  if (view.isLoading) {
    return <SegmentsTableLoading />;
  }

  if (view.error) {
    return <SegmentsTableError error={view.error} />;
  }

  return (
    <div className={styles.listView}>
      <SegmentsToolbar {...view} />
      <SegmentsTable {...view} />
    </div>
  );
}
